import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { ThemeToggle } from './ui/ThemeToggle';
import { AdaptiveLogo } from './ui/AdaptiveLogo';
import { useAuth } from '../hooks/useAuth';
import { Circle, Settings, Coins, Users2, PlusSquare, MessagesSquare, LibraryBig, Music, Wrench, Sparkles, AudioWaveform, Home, Zap, Headphones, LogOut } from 'lucide-react';

export const Sidebar = () => {
    const { logout: auth0Logout, isAuthenticated: auth0IsAuthenticated } = useAuth0();
    const { logout: customLogout, isAuthenticated: customIsAuthenticated, refreshAuthState } = useAuth();

    React.useEffect(() => {
        refreshAuthState();
    }, [refreshAuthState]);

    const handleLogout = () => {
        customLogout();
        auth0Logout({ logoutParams: { returnTo: window.location.origin } });

        setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
        }, 100);
    };

    const isAuthenticated = auth0IsAuthenticated && customIsAuthenticated;

    return (
        <div className="w-56 h-screen bg-card border-r border-border flex flex-col shadow-sm">
            <div className="p-4 border-b border-border">
                <div className="flex items-center gap-3">
                    <AdaptiveLogo />
                    <div className="w-px h-4 bg-border select-none" />
                    <h1 className="text-sm font-medium text-card-foreground select-none">Delphos Copilot</h1>
                </div>
            </div>

            <div className="px-4 pt-4 mb-2">
                <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Soundworlds</h2>
            </div>
            <div className="space-y-1 px-2">
                <NavLink
                    to="/home"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <Home size={ 18 } />
                    <span className="text-sm font-medium truncate">Home</span>
                </NavLink>

                <NavLink
                    to="/catalogue"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <Zap size={ 18 } />
                    <span className="text-sm font-medium truncate">Fast Track</span>
                </NavLink>

                <NavLink
                    to="/explore"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <Music size={ 18 } />
                    <span className="text-sm font-medium truncate">Generate Songs</span>
                </NavLink>

                <NavLink
                    to="/train"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <Headphones size={ 18 } />
                    <span className="text-sm font-medium truncate">Train Soundworld</span>
                </NavLink>

                <NavLink
                    to="/audio-utilities"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <AudioWaveform size={ 18 } />
                    <span className="text-sm font-medium truncate">Audio Utilities</span>
                </NavLink>
            </div>

            <div className="flex-1" />

            <div className="p-4 border-t border-border space-y-2">
                <NavLink
                    to="/credits"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <Coins size={ 18 } />
                    <span className="text-sm font-medium">Buy Credits</span>
                </NavLink>

                {/* <NavLink
                    to="/#"
                    className={ ({ isActive }) =>
                        `w-full flex items-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-accent text-accent-foreground font-semibold'
                            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                        }`
                    }
                >
                    <Settings size={ 18 } />
                    <span className="text-sm font-medium">Settings</span>
                </NavLink> */}

                <div className="flex items-center gap-2">
                    <ThemeToggle />
                    { isAuthenticated && <button
                        onClick={ handleLogout }
                        className="flex-1 flex items-center text-sm bg-accent justify-center gap-2 px-2 py-2 rounded-lg transition-colors duration-200 text-accent-foreground font-medium hover:opacity-80"
                    >
                        <LogOut size={ 18 } />
                        Sign Out
                    </button> }
                </div>
            </div>
        </div>
    )
}
